<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>退货订单</span>
        <el-button
          type="primary"
          size="small"
          style="float: right;"
          @click="_openAddShopHouseModal()"
        >
          <i class="el-icon-plus"></i>选择订单
        </el-button>
      </div>
      <table class="custom-table">
        <thead>
          <tr>
            <th>编号</th>
            <th>名称</th>
            <th>规格</th>
            <th>进货数量</th>
            <th>数量</th>
            <th>单价</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in downShopHouseOutManageInfo.inoutOrderProducts" :key="index">
            <td>{{ item.productId }}</td>
            <td>{{ item.prodName }}</td>
            <td>{{ item.specName }}</td>
            <td>{{ item.prodCount }}</td>
            <td>
              <input
                v-model.number="item.count"
                type="number"
                class="custom-input"
                @input="_caculTotalMount()"
              />
            </td>
            <td>
              <input
                v-model.number="item.price"
                type="number"
                class="custom-input"
                @input="_caculTotalMount()"
              />
            </td>
            <td>
              <el-button
                type="text"
                size="small"
                @click="_deleteProduct(item)"
              >删除</el-button>
            </td>
          </tr>
        </tbody>
      </table>
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="flex justify-between">
        <span>说明</span>
      </div>
      <el-form label-width="100px">
        <el-form-item label="金额">
          <span style="font-size: 14px; color: red;">{{downShopHouseOutManageInfo.totalMount}}</span>
        </el-form-item>
        <el-form-item label="退货说明">
          <textarea
            v-model="downShopHouseOutManageInfo.remark"
            placeholder="必填，请填写退货说明"
            maxlength="250"
            style="width: 100%; padding: 5px; border: 1px solid #dcdfe6; border-radius: 4px; min-height: 80px; resize: vertical;"
          ></textarea>
          <div style="text-align: right; color: #909399; font-size: 12px; margin-top: 5px;">
            {{ downShopHouseOutManageInfo.remark ? downShopHouseOutManageInfo.remark.length : 0 }}/250
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="_doInoutOrder()">
            <i class="el-icon-check"></i>提交
          </el-button>
          <el-button type="warning" @click="_goBack()" style="margin-left: 20px;">
            <i class="el-icon-close"></i>取消
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <choose-inout-order
      ref="chooseInoutOrder"
      @chooseInoutOrder="handleChooseInoutOrder"
    ></choose-inout-order>
  </div>
</template>

<script>
import { saveInoutOrder, queryInoutOrderProduct } from '@/api/goods/downShopHouseOutManageApi'
import { getShopId } from '@/api/shop/shopApi'
import ChooseInoutOrder from '@/components/goods/chooseInoutOrder/chooseInoutOrder'

export default {
  name: 'DownShopHouseOutManage',
  components: {
    ChooseInoutOrder
  },
  data() {
    return {
      downShopHouseOutManageInfo: {
        inoutOrderProducts: [],
        remark: '',
        orderType: '20000',
        orderId: '',
        totalMount: 0.0,
        relOrderId: '',
        shopId: ''
      },
      total: 0,
      pageSize: 15
    }
  },
  created() {
    this.downShopHouseOutManageInfo.shopId = getShopId()
  },
  methods: {
    _openAddShopHouseModal() {
      this.$refs.chooseInoutOrder.open({
        state: '8008'
      })
    },
    handleChooseInoutOrder(product) {
      this.downShopHouseOutManageInfo.orderId = product.orderId
      this.downShopHouseOutManageInfo.relOrderId = product.orderId
      this._listInoutOrderProduct()
    },
    async _listInoutOrderProduct() {
      try {
        const res = await queryInoutOrderProduct({
          page: 1,
          row: 50,
          orderId: this.downShopHouseOutManageInfo.orderId,
          shopId: this.downShopHouseOutManageInfo.shopId
        })
        this.downShopHouseOutManageInfo.inoutOrderProducts = res.data || []
        // 为每个商品添加 count 和 price 字段（如果不存在）
        this.downShopHouseOutManageInfo.inoutOrderProducts.forEach(item => {
          if (item.count === undefined || item.count === null) {
            item.count = item.prodCount || 0
          }
          if (item.price === undefined || item.price === null) {
            item.price = 0
          }
        })
        this._caculTotalMount()
      } catch (error) {
        console.error('获取订单商品失败:', error)
        this.$message.error('获取订单商品失败')
      }
    },
    async _doInoutOrder() {
      const _inoutOrderProducts = this.downShopHouseOutManageInfo.inoutOrderProducts
      if (_inoutOrderProducts.length < 1) {
        this.$message.warning('请选择商品')
        return
      }
      if (!this.downShopHouseOutManageInfo.remark) {
        this.$message.warning('退货说明不能为空')
        return
      }

      try {
        for (const item of _inoutOrderProducts) {
          if (!item.count || item.count <= 0) {
            this.$message.warning('请输入正确的数量')
            return
          }
          if (parseInt(item.count) > parseInt(item.prodCount)) {
            this.$message.warning('退货数量不能大于进库数量')
            return
          }
        }

        const res = await saveInoutOrder(this.downShopHouseOutManageInfo)
        if (res.code === 0) {
          this.$message.success(res.msg)
          this._goBack()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('提交退货订单失败:', error)
        this.$message.error('提交退货订单失败')
      }
    },
    _goBack() {
      this.$router.go(-1)
    },
    _deleteProduct(inoutOrderProduct) {
      const index = this.downShopHouseOutManageInfo.inoutOrderProducts.indexOf(inoutOrderProduct)
      if (index > -1) {
        this.downShopHouseOutManageInfo.inoutOrderProducts.splice(index, 1)
      }
    },
    _caculTotalMount() {
      let total = 0
      try {
        this.downShopHouseOutManageInfo.inoutOrderProducts.forEach(item => {
          if (!isNaN(item.count) && !isNaN(item.price)) {
            total += parseFloat(item.count) * parseFloat(item.price)
          } else {
            throw new Error('请输入正确的数字')
          }
        })
        this.downShopHouseOutManageInfo.totalMount = total.toFixed(2)
      } catch (error) {
        this.downShopHouseOutManageInfo.totalMount = '请输入正确的数字'
      }
    },
    handleCurrentChange(val) {
      console.log(val)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #EBEEF5;
  font-size: 14px;
  color: #606266;
}

.custom-table thead {
  background-color: #F5F7FA;
}

.custom-table th {
  padding: 12px 0;
  text-align: center;
  border-bottom: 1px solid #EBEEF5;
  border-right: 1px solid #EBEEF5;
  font-weight: 500;
  color: #909399;
  font-size: 14px;
}

.custom-table th:last-child {
  border-right: none;
}

.custom-table tbody tr {
  border-bottom: 1px solid #EBEEF5;
}

.custom-table tbody tr:last-child {
  border-bottom: none;
}

.custom-table tbody tr:hover {
  background-color: #F5F7FA;
}

.custom-table td {
  padding: 12px 0;
  text-align: center;
  border-right: 1px solid #EBEEF5;
}

.custom-table td:last-child {
  border-right: none;
}

.custom-input {
  width: 100%;
  height: 32px;
  line-height: 32px;
  padding: 0 15px;
  box-sizing: border-box;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  background-color: #FFF;
  outline: none;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.custom-input:hover {
  border-color: #C0C4CC;
}

.custom-input:focus {
  border-color: #409EFF;
  outline: none;
}

.custom-input:disabled {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #C0C4CC;
  cursor: not-allowed;
}
</style>